import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import Actions_Wind from '~/Actions_Wind';
import excel from '~/skills/excel';
import { S_Btn_Search, S_Select, S_Title } from '~/components/SearchItem';
import { T_TableRow, T_TitleCell } from '~/components/TableItem';
import PageTitle from '~/components/PageTitle';
import ExportButton from '~/components/Button/ExportButton';
import SearchBar from '~/components/SearchBar';

const RenderTableTitle = () => {
  const GisPerMonth = useSelector(state => state.data.GisPerMonth || []);
  const ary = [
    { name: '項目' },
    ...(GisPerMonth?.labelAry?.[0]?.date || []).map(o => ({ name: o })),
    ...(GisPerMonth?.labelAry?.[1]?.date || []).map(o => ({ name: o })),
  ];

  return (
    <TableHead>
      <TableRow style={{ height: 48 }}>
        {ary.map((o, i) => (
          <T_TitleCell
            key={i}
            text={o.name}
            color='#247691'
          />
        ))}
      </TableRow>
    </TableHead>
  );
};

const RenderTableBody = () => {
  const GisPerMonth = useSelector(state => state.data.GisPerMonth || []);
  const cellStyle = { fontSize: 14 };
  const leftLength = GisPerMonth?.labelAry?.[0]?.date?.length || 0;
  const rightLength = GisPerMonth?.labelAry?.[1]?.date?.length || 0;
  return (
    <TableBody>
      {(GisPerMonth?.list || []).map((o1, i1) => {
        const renderAry = [
          <T_TableRow key={`${i1}`} disOver>
            <TableCell align='center' style={{ color: 'black', fontWeight: 700, backgroundColor: '#EBF3F5', ...cellStyle, whiteSpace: 'nowrap' }}>
              {o1.stageName}
            </TableCell>
            <TableCell style={{ backgroundColor: '#EBF3F5' }} colSpan={leftLength} align='center'>{i1 === 0 && '填入實際工進'}</TableCell>
            <TableCell style={{ backgroundColor: '#EBF3F5' }} colSpan={rightLength} align='center'>{i1 === 0 && '填入規劃工進'}</TableCell>
          </T_TableRow>,
          ...o1.itemList.map((o2, i2) => (
            <T_TableRow key={`${i1}_${i2}`}>
              <TableCell align='center' style={{ color: '#247691', fontWeight: 400, ...cellStyle, whiteSpace: 'nowrap' }}>{o2.item}</TableCell>
              {(o2.list[0] || []).map((o3, i3) => <TableCell key={`${i1}_${i2}_${i3}_3`} align='center' style={{ ...cellStyle, backgroundColor: (i2 % 2 === 1) ? 'transparent' : '#FFEDED' }}>{o3}</TableCell>)}
              {(o2.list[1] || []).map((o3, i3) => <TableCell key={`${i1}_${i2}_${i3}_3`} align='center' style={{ ...cellStyle, backgroundColor: (i2 % 2 === 1) ? 'transparent' : '#CCF1F3' }}>{o3}</TableCell>)}
            </T_TableRow>
          )),
        ];
        return renderAry;
      })}
    </TableBody>
  );
};

const RenderTable = () => {
  const GisPerMonth = useSelector(state => state.data.GisPerMonth || []);
  return (
    <TableContainer>
      <Table style={{ backgroundColor: 'white', borderRadius: 8 }}>
        <RenderTableTitle />
        <RenderTableBody />
      </Table>
    </TableContainer>
  );
};

const App = props => {
  const {} = props;
  const [data, setData] = useState({ windId: '' });
  const { windId } = data;
  const dispatch = useDispatch();
  const SwitchProjectList = useSelector(state => state.data.SwitchProjectList || []);
  const GisPerMonth = useSelector(state => state.data.GisPerMonth || []);
  const onClickSearch = () => { if (windId) Actions_Wind.Gis.getGisPerMonth(dispatch, { id: windId }); };
  const haveData = (GisPerMonth?.labelAry?.[0]?.date?.length > 0) || (GisPerMonth?.labelAry?.[1]?.date?.length > 0);

  const onExport = () => {
    if (!haveData) alert('無匯出資料');
    else {
      let name = '';
      SwitchProjectList.forEach(o => {
        if (o.value === windId)name = o.name;
      });
      excel.outputAryAry({
        header: ['項目', ...GisPerMonth?.labelAry?.[0]?.date, ...GisPerMonth?.labelAry?.[1]?.date],
        data: [
          [GisPerMonth.list[0].stageName, ...GisPerMonth?.labelAry?.[0]?.date.map((o, i) => { if (i) return ''; else return '填入實際工進'; }), '填入規劃工進'],
          ...GisPerMonth.list[0].itemList.map(o => [o.item, ...o.list[0], ...o.list[1]]),
          [GisPerMonth.list[1].stageName],
          ...GisPerMonth.list[1].itemList.map(o => [o.item, ...o.list[0], ...o.list[1]]),
          [GisPerMonth.list[2].stageName],
          ...GisPerMonth.list[2].itemList.map(o => [o.item, ...o.list[0], ...o.list[1]]),
        ],
        fileName: `每月規劃進度_${name}`,
      });
    }
  };
  useEffect(() => () => Actions_Wind.clearKey(dispatch, { key: 'GisPerMonth' }), []);

  return (
    <div style={{
      position: 'absolute',
      left: 13,
      right: 0,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      overflow: 'auto',
    }}
    >
      <PageTitle text='每月規劃進度' />

      <div key='1' style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse' }}>
        <ExportButton style={{ marginRight: 28 }} onClick={onExport} />
      </div>
      <SearchBar style={{ marginTop: 24 }} defaultOpen>
        <div style={{ display: 'flex' }}>
          <div style={{ marginLeft: 16 }}>
            <S_Title text='風場' />
            <S_Select list={SwitchProjectList} value={windId} onChange={t => setData({ ...data, windId: t })} />
          </div>
          <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
            <S_Btn_Search onClick={onClickSearch} />
          </div>
        </div>
        <div style={{ marginLeft: 52, marginRight: 52, marginTop: 20, marginBottom: 20 }}>
          <div style={{ borderRadius: 8, boxShadow: '0px 4px 13px rgba(24, 98, 121, 0.4)' }}>
            {haveData && <RenderTable />}
            {/* {haveData && this.renderTableBar()} */}
          </div>
          {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
        </div>
      </SearchBar>
    </div>
  );
};

export default App;
